import {
  Add,
  Clear,
  Description,
  ExpandCircleDown,
  KeyboardArrowDown,
  ReportOutlined,
  Search,
  UploadFile,
  Visibility,
  VisibilityOff
} from "@mui/icons-material";
import {
  Autocomplete,
  Button,
  Grid,
  IconButton,
  InputAdornment,
  List,
  TextField,
  Tooltip,
  Typography,
  createFilterOptions,
  tooltipClasses
} from "@mui/material";
import { FastField, Formik } from "formik";
import React from "react";
import styled from "styled-components";

const FontSize = {
  LabelMarginBottom: "5px !important",
  textFieldLabel: "14px",
  textField: "13.5px"
};

const Appcolors = {
  title: "#202124",
  backgroundColor: "#f0f2f5",
  textFiled: "#3a4c6b",
  textFiledDisabled: "#00000099",
  backgroundDisabled: "#0000000f",
  success: "",
  error: "",
  warn: "",
  default: ""
};

const HtmlTooltip = styled(({ className, ...props }) => (
  <Tooltip {...props} classes={{ popper: className }} />
))(({ theme }) => ({
  [`& .${tooltipClasses.tooltip}`]: {
    backgroundColor: "#f5f5f9",
    color: "rgba(0, 0, 0, 0.87)",
    maxWidth: 220,
    fontSize: theme.typography.pxToRem(12),
    border: "1px solid #dadde9"
  }
}));

const filterOptions = createFilterOptions({
  ignoreCase: true,
  matchFrom: "start",
  limit: 10
});

const filterAndKeepFirstDuplicate = (arr, name) => {
  const seenMaMuc = new Set();

  return arr?.filter(obj => {
    const maMuc = obj[name];
    if (!seenMaMuc.has(maMuc)) {
      seenMaMuc.add(maMuc);
      return true;
    }

    return false;
  });
};

const ListBoxComponent = React.forwardRef(function ListBoxComponent(
  props,
  ref
) {
  const { children, role, ...other } = props;
  const itemCount = Array.isArray(children) ? children.length : 0;
  const itemSize = 36;
  const listHeight = itemCount <= 8 ? itemCount * itemSize : 250;
  return (
    <div ref={ref} style={{ paddingTop: 5 }}>
      <div {...other} style={{ overflow: "hidden", padding: 0 }}>
        <List
          height={listHeight}
          width={1}
          style={{ width: "100%" }}
          containerStyle={{ width: "100%", maxWidth: "100%" }}
          rowHeight={itemSize}
          overscanCount={5}
          rowCount={itemCount}
          rowRenderer={props => {
            return React.cloneElement(children[props.index], {
              style: { ...props.style, fontSize: 14, paddingLeft: 5 }
            });
          }}
          role={role}
        />
      </div>
    </div>
  );
});

export const MyForm = ({
  width,
  formikRef,
  childrenSearch,
  children,
  customSearch,
  dataFormik,
  validationSchema,
  onSubmitAPI,
  handleAdd,
  showSearch,
  showExcel,
  handleExportExcel,
  handleImportExcel,
  handleChange,
  editable = true,
  showFormikState,
  isql,
  kvtk,
  marginBottom
}) => {
  return (
    <Grid
      item
      sx={{ width: width ? width : null }}
      mb={marginBottom || 0}
      style={{ zIndex: 3000 }}
    >
      <Formik
        validateOnChange={false}
        validateOnBlur={false}
        innerRef={formikRef}
        enableReinitialize={true}
        initialValues={dataFormik}
        validationSchema={validationSchema}
        onSubmit={(values, actions) => {
          onSubmitAPI(values, actions);
        }}
      >
        {props => (
          <form onSubmit={props.handleSubmit} autoComplete="false">
            <div>
              {children ? children(props) : null}
              {showSearch ? (
                <Grid container marginTop={"10px"}>
                  {customSearch ? (
                    <TextField
                      name="search"
                      placeholder="Tìm kiếm..."
                      variant="outlined"
                      type="search"
                      value={props.values.search}
                      onChange={e => {
                        props.setFieldValue("search", e.target.value);
                      }}
                      InputProps={{
                        endAdornment: (
                          <InputAdornment position="end">
                            {props.values.search.length > 0 ? (
                              <IconButton
                                onClick={() => {
                                  props.setFieldValue("search", "");
                                }}
                              >
                                <Clear fontSize="small" />
                              </IconButton>
                            ) : (
                              <Search sx={{ fontSize: "20px" }} />
                            )}
                          </InputAdornment>
                        ),
                        sx: {
                          height: "33px",
                          color: "#3a4c6b",
                          fontSize: FontSize.textField,
                          "& .MuiOutlinedInput-input": {
                            padding: "12px 0px 12px 15px!important"
                          }
                        }
                      }}
                      sx={{
                        ".MuiFormHelperText-root": {
                          color: "#f44335 !important",
                          marginTop: "5px !important",
                          paddingLeft: "5px !important",
                          fontSize: "13px"
                        },
                        "& .MuiOutlinedInput-root": {
                          "& fieldset": {
                            borderColor: "#cbd5e0 !important"
                          },
                          "&:hover fieldset": {
                            borderColor: "#a0a0a0 !important"
                          },
                          "&.Mui-focused fieldset": {
                            border: "1px solid #1a73e8 !important"
                          }
                        }
                      }}
                    />
                  ) : (
                    <Grid item xs={6}>
                      <FastField
                        name="search"
                        render={({ field }) => (
                          <Search
                            placeholder="Tìm kiếm..."
                            onSubmitAPI={onSubmitAPI}
                            formikRef={formikRef}
                            {...field}
                          />
                        )}
                      />
                    </Grid>
                  )}

                  {/* <MyButton
                                        txt="Tìm kiếm"
                                        type="submit"
                                        // style={{width: 150, height: 26}}
                                        icon={<SearchRoundedIcon />}
                                    /> */}
                  {editable && handleAdd && !kvtk && (
                    <Grid
                      item
                      xs={6}
                      display={"flex"}
                      justifyContent={"flex-end"}
                    >
                      <MyButton
                        onClick={handleAdd}
                        txt="Thêm mới"
                        // style={{width: 160, height: 26}}
                        icon={<Add />}
                      />
                    </Grid>
                  )}

                  {showExcel && editable && (
                    <MyButton
                      txt="Xuất File Excel"
                      color="#1da51de6"
                      onClick={handleExportExcel}
                      icon={<Description />}
                    />
                  )}

                  {showExcel && editable && (
                    <MyButton
                      txt="Nhập File Excel"
                      color="#1da51de6"
                      onClick={handleImportExcel}
                      icon={<UploadFile />}
                    />
                  )}
                  {childrenSearch ? childrenSearch : null}
                </Grid>
              ) : (
                ""
              )}
            </div>
          </form>
        )}
      </Formik>
    </Grid>
  );
};

export const MyButton = React.forwardRef(
  (
    {
      height,
      size,
      type,
      onClick,
      disabled,
      color,
      icon,
      width,
      fontSizeIcon,
      txt,
      handleUploadfile,
      uploadfile,
      marginRightStartIcon,
      multiple = false,
      ...rest
    },
    ref
  ) => {
    return (
      <Button
        type={type}
        onClick={onClick}
        disabled={disabled != null ? !disabled : false}
        sx={{
          "&.MuiButton-containedPrimary": {
            backgroundColor: color ? color : "#2b713a",
            fontSize: "13px",
            minWidth: width,
            color: "#ffffff",
            textTransform: "none",
            boxShadow: "none"
          },
          ".MuiButton-startIcon>*:nth-of-type(1)": {
            fontSize: fontSizeIcon && fontSizeIcon
          },
          "& .MuiButton-endIcon": { paddingBottom: "0px" },
          "& .MuiButton-startIcon": {
            paddingBottom: "0px",
            marginRight: marginRightStartIcon ? marginRightStartIcon : "3px"
          }
        }}
        style={{ height: height ? height : "33px" }}
        variant="contained"
        size={size ? size : "small"}
        startIcon={icon}
        {...rest}
      >
        <div style={{ paddingTop: 0 }}>{txt}</div>
        {uploadfile === true ? (
          <input
            type="file"
            hidden
            multiple={multiple}
            onClick={event => {
              event.target.value = null;
            }}
            onChange={item => handleUploadfile(item)}
          />
        ) : (
          ""
        )}
      </Button>
    );
  }
);

export const MySelect = React.forwardRef(
  (
    {
      width,
      multiple,
      clearAble,
      isFilterOptions,
      required,
      helperText,
      onChange,
      value,
      label,
      name,
      tooltip = false,
      tooltipContent,
      options,
      placeholder,
      errors,
      height,
      disabled,
      offPaddingBottom,
      disableClearable = false,
      defaultValue,
      ...rest
    },
    ref
  ) => {
    const newOptions = React.useMemo(() => {
      const arr = filterAndKeepFirstDuplicate(options, name);
      return arr;
    }, [options, name]);
    return (
      <div
        style={{
          width: width,
          paddingBottom: offPaddingBottom
            ? "0px !important"
            : FontSize.DivLabelMarginBottom,
          alignSelf: "self-start"
        }}
      >
        {required ? (
          <Typography
            sx={{
              marginBottom: label
                ? FontSize.LabelMarginBottom
                : "0px !important",
              fontSize: FontSize.textFieldLabel
            }}
            variant="body2"
            color={errors ? "#f44335" : "#000000b3"}
          >
            {label}
            <span style={{ color: "red" }}> *</span>
          </Typography>
        ) : (
          <Typography
            sx={{
              marginBottom: label
                ? FontSize.LabelMarginBottom
                : "0px !important",
              fontSize: FontSize.textFieldLabel
            }}
            variant="body2"
            color={errors ? "#f44335" : "#000000b3"}
          >
            {label}
          </Typography>
        )}
        <Autocomplete
          value={value}
          fullWidth
          multiple={multiple}
          options={newOptions}
          filterOptions={isFilterOptions && filterOptions}
          disableClearable={
            clearAble
              ? !clearAble
              : disableClearable
              ? disableClearable
              : value
              ? false
              : true
          }
          defaultValue={defaultValue ? defaultValue : undefined}
          onChange={onChange}
          popupIcon={
            <KeyboardArrowDown
              style={{ color: "#8080808a", fontSize: "20px" }}
            />
          }
          getOptionLabel={(option, index) => {
            return typeof option === "string"
              ? option
              : typeof option === "object"
              ? option[name]
              : "";
          }}
          ListboxComponent={newOptions?.length > 100 ? ListBoxComponent : null}
          renderOption={(props, option, { selected }) => {
            return (
              <li {...props}>
                {tooltip ? (
                  <HtmlTooltip
                    placement="left"
                    title={
                      <div {...props}>
                        {tooltipContent &&
                          tooltipContent.map((e, i) => (
                            <div key={i}>
                              {option[e.content] !== null ? (
                                <Typography
                                  color={"#344767e3"}
                                  sx={{ fontSize: "14px" }}
                                >
                                  <b>{e.title}</b> : {option[e.content]}
                                </Typography>
                              ) : (
                                ""
                              )}
                            </div>
                          ))}
                      </div>
                    }
                  >
                    <Typography color={"#344767e3"} sx={{ fontSize: "14px" }}>
                      {option[name]}
                    </Typography>
                  </HtmlTooltip>
                ) : (
                  <Typography color={"#344767e3"} sx={{ fontSize: "14px" }}>
                    {option[name]}
                  </Typography>
                )}
              </li>
            );
          }}
          sx={{
            "& .MuiOutlinedInput-root": {
              padding: "4.5px",
              paddingLeft: "15px",
              color: Appcolors.textFiled,
              fontSize: FontSize.textField,
              textOverflow: "ellipsis",
              backgroundColor: disabled
                ? Appcolors.backgroundDisabled
                : "white",
              height: height ? height : "33px",
              "& .MuiAutocomplete-input": {
                height: "100%",
                padding: "0px",
                textOverflow: "ellipsis"
              },
              "& .MuiAutocomplete-tag": {
                height: "100%",
                marginBottom: "-2px"
              }
            }
          }}
          disabled={disabled}
          renderInput={params => (
            <TextField
              {...params}
              helperText={errors && helperText}
              placeholder={placeholder}
              sx={{
                ".MuiFormHelperText-root": {
                  color: "#f44335 !important",
                  marginTop: "5px !important",
                  marginRight: "0px",
                  marginLeft: "0px",
                  paddingLeft: "5px !important",
                  fontSize: "13px"
                },

                "& .MuiOutlinedInput-root": {
                  "& fieldset": {
                    borderColor: errors
                      ? "#e91e63 !important"
                      : "#cbd5e0 !important"
                  },
                  "&:hover fieldset": {
                    borderColor: "#a0a0a0 !important"
                  },
                  "&.Mui-focused fieldset": {
                    border: errors
                      ? "1px solid #e91e63 !important"
                      : "1px solid #1a73e8 !important"
                  }
                },
                ".MuiOutlinedInput-input.Mui-disabled": {
                  WebkitTextFillColor: Appcolors.textFiledDisabled
                }
              }}
              variant="outlined"
            />
          )}
          renderTags={list => {
            let displayList = list
              .map(item => Object.values(item)[1])
              .join(", ");

            // Render <span> elements instead of <Chip> components.
            return <span>{displayList}</span>;
          }}
          {...rest}
        />
      </div>
    );
  }
);

export const MyTextField = React.forwardRef(
  (
    {
      width,
      required,
      helperText,
      label,
      height,
      disabled,
      errors,
      type,
      onClear,
      onChange,
      readOnly,
      onBlur,
      onClick,
      value,
      InputProps,
      onKeyDown,
      measure,
      ...rest
    },
    ref
  ) => {
    const [hover, setHover] = React.useState(false);
    return (
      <div style={{ width: width ? width : "100%", alignSelf: "self-start" }}>
        {required ? (
          <Typography
            sx={{
              marginBottom: FontSize.LabelMarginBottom,
              fontSize: FontSize.textFieldLabel
            }}
            variant="body2"
            color={errors ? "#f44335" : "#000000b3"}
          >
            {label}
            {measure}
            <span style={{ color: "red" }}>*</span>
          </Typography>
        ) : (
          <Typography
            sx={{
              marginBottom: FontSize.LabelMarginBottom,
              fontSize: FontSize.textFieldLabel
            }}
            variant="body2"
            color={errors ? "#f44335" : "#000000b3"}
          >
            {label}
            {measure}
          </Typography>
        )}
        <div
          style={{
            position: "relative",
            display: "inline-block",
            width: "100%"
          }}
        >
          <TextField
            {...rest}
            helperText={errors && helperText}
            variant="outlined"
            type={type ? type : "search"}
            fullWidth
            value={value}
            disabled={disabled}
            onChange={onChange}
            onFocus={onClick}
            onMouseEnter={() => setHover(true)}
            onMouseLeave={() => setHover(false)}
            onKeyDown={e => {
              typeof onKeyDown === "function" ? onKeyDown(e) : console.log();
            }}
            onBlur={onBlur}
            InputProps={
              InputProps
                ? InputProps
                : {
                    readOnly: readOnly,
                    startAdornment: (
                      <InputAdornment position="start">
                        {rest.status && (
                          <ExpandCircleDown
                            style={{
                              fontSize: "18px",
                              color: `${
                                rest.status === "current"
                                  ? "#969696"
                                  : rest.status === "new"
                                  ? "#40eb34"
                                  : rest.status === "update"
                                  ? "#edb139"
                                  : rest.status === "empty"
                                  ? "#f44335"
                                  : ""
                              }`
                            }}
                          />
                        )}
                      </InputAdornment>
                    ),
                    endAdornment: (
                      <InputAdornment position="end">
                        {!onClear && errors ? (
                          <ReportOutlined
                            sx={{ fontSize: "16px", color: "#f44335" }}
                          />
                        ) : (
                          <></>
                        )}
                        {rest?.showpassword &&
                          (rest?.openeye ? (
                            <IconButton onClick={() => rest?.showpassword()}>
                              <Visibility sx={{ fontSize: "18px" }} />
                            </IconButton>
                          ) : (
                            <IconButton onClick={() => rest?.showpassword()}>
                              <VisibilityOff sx={{ fontSize: "18px" }} />
                            </IconButton>
                          ))}
                        {!disabled && onClear && (
                          <IconButton
                            style={{
                              position: "absolute",
                              top: "-2px",
                              margin: "auto",
                              right: "4px"
                            }}
                            onClick={() => onClear()}
                          >
                            <Clear fontSize="small" />
                          </IconButton>
                        )}
                      </InputAdornment>
                    ),
                    sx: {
                      backgroundColor: disabled
                        ? Appcolors.backgroundDisabled
                        : "white",
                      height: height ? height : "33px !important",
                      color: Appcolors.textFiled,
                      fontSize: FontSize.textField,
                      "& .MuiOutlinedInput-input": {
                        textOverflow: "ellipsis"
                      },
                      "& .MuiOutlinedInput-input.Mui-disabled": {
                        WebkitTextFillColor: Appcolors.textFiledDisabled
                      }
                    }
                  }
            }
            sx={{
              ".MuiFormHelperText-root": {
                color: "#f44335 !important",
                marginTop: "5px !important",
                marginRight: "0px",
                marginLeft: "0px",
                paddingLeft: "5px !important",
                fontSize: "13px"
              },
              "& .MuiOutlinedInput-root": {
                "& fieldset": {
                  borderColor: errors
                    ? "#e91e63 !important"
                    : "#cbd5e0 !important"
                },
                "&:hover fieldset": {
                  borderColor: "#a0a0a0 !important"
                },
                "&.Mui-focused fieldset": {
                  border: errors
                    ? "1px solid #e91e63 !important"
                    : "1px solid #1a73e8 !important"
                }
              }
            }}
          />
        </div>
      </div>
    );
  }
);
